import { render } from "./RadioList.vue?vue&type=template&id=6048c47c"
import script from "./RadioList.vue?vue&type=script&lang=js"
export * from "./RadioList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__